import { OutboundSyncStatus } from "@/components/sync/types";
import { Duration } from "luxon";
import { useEffect, useState } from "react";
import { useTimeout } from "usehooks-ts";

const SYNC_INDICATOR_TIMEOUT = Duration.fromObject({ seconds: 4 });

export const useShowSpinner = (status: OutboundSyncStatus) => {
  const [showSpinner, setShowSpinner] = useState(false);

  useTimeout(
    () => {
      setShowSpinner(status === OutboundSyncStatus.Syncing);
    },
    status === OutboundSyncStatus.Syncing ? SYNC_INDICATOR_TIMEOUT.as("milliseconds") : null
  );

  useEffect(() => {
    if (status !== OutboundSyncStatus.Syncing) {
      setShowSpinner(false);
    }
  }, [status]);

  return showSpinner;
};
